import { UserData } from 'appRootPath/shared/global-meta-data';

export type FileTypes = '.pdf' | '.doc';

export type RoleTypes = 'issuer' | 'investor' | 'ipa';

export type RoleTypeNumber = 1 | 2 | 3;

/* eslint-disable @typescript-eslint/indent */
export type DocumentKeys = 'master_creation_form' | 'letter_of_offer' | 'deal_confirmation_note'
  | 'promissory_note' | 'covering_letter' | 'eligibility_letter' | 'rbi_letter' | 'ipa_certificate'
  | 'cp_allotment' | 'CAF' | 'caf_issuance_letter' | 'depository_input_csv' | 'AnnexureAForBSE'
  | 'BSEAnnexureBFresh' | 'BSEAnnexureBFurther' | 'BSEListInvestors' | 'BSEAnnexureIK'
  | 'AnnexureAFormAForBSE' | 'stamp_paper_doc';

export type BidAction = 'reject_bid' | 'accept_bid' | 'counter_bid' | 'counter_negotiation'
  | 'reject_negotiation' | 'accept_negotiation' | 'reevaluation_accepted' | 'reevaluation_rejected'
  | 'bid_placed' | 'place_bid' | 'accept_bid_with_cbc' | 'auction_closed';

export type IpaChecklistConditions = 'is_ipa_agreement_valid' | 'covering_letter' |
  'board_Resolution' | 'auth_signatory_list' | 'credit_rating_letters' | 'letter_of_offer'
  | 'deal_confirmation_note' | 'stamp_paper' | 'promissory_note' | 'letter_for_rbi' |
  'eligibility_letter' | 'credit_enhancement_letter' |
  'borrowing_limit_board_resolution' | 'cp_value_within_borrowing_limit' |
  'credit_ratings_valid' | 'cp_value_within_rating_limit' | 'min_credit_ratings' |
  'min_credit_Ratings_certificate' | 'value_date_within_credit_rating_validity' |
  'value_date_within_date_offer_letter' | 'maturity_within_rating_validity' |
  'is_purpose_set' | 'networth_limit' | 'borrowing_classification' | 'cp_tenure'
  | 'value_date_mumbai_business_day' | 'redemption_date_mumbai_business_day'
  | 'cp_denomination' | 'stamp_duty_promissory_note' | 'documents_signed_authorized'
  | 'sec_2-76' | 'cp_defaults_6mnths' | 'independent_trustee';

/* eslint-enable @typescript-eslint/indent */

export type FormStatus = 'INVALID' | 'VALID';

export interface ViewModalDocFormat {
  title: string;
  additionalData?: string;
  document_url: string;
}

export interface BidActionsMap {
  [key: string]: BidAction;
}

export interface NextActionMap {
  [key: string]: NextActionDetails;
}

export interface NextActionDetails {
  btnText: string;
  btnColorMod: string;
  asideTitle: string;
  asideBtn: string;
  asideOtherHeader: string;
  asideFormHeader: string;
  asideShowOtherBid: boolean;
}

export interface RoleAssociatedState {
  id: string;
  role: string;
  modified_at: string;
  created_at: string;
  status: boolean;
  name: string | null;
  state_role_type: number;
}

export interface PartyRoleMembership {
  id: string;
  AssociatedState: RoleAssociatedState[];
  party_user: string;
  modified_at: string;
  created_at: string;
  status: boolean; role: string;
}

export interface PartyUserProfile {
  id: string;
  email: string;
  name: string;
  mobile_number: string;
  pan: string;
  phone_number: string;
  tnc_signed: boolean;
}

export interface UserProfile {
  id: string;
  party_user: PartyUserProfile[];
  party_role_membership: PartyRoleMembership[];
  corporate_id: string;
  modified_at: string;
  created_at: string;
  status: boolean;
  dob: string;
  designation: string;
  tnc_signed: boolean;
  party_role: string[];
}


export interface CurrentUserRoles {
  hasInvestorRole: boolean;
  hasIssuerRole: boolean;
  hasIpaRole: boolean;
}

export interface StateRole {
  created_at: string;
  id: string;
  modified_at: string;
  name: string | null;
  role: string;
  state_role_type: number;
  status: boolean;
}

export interface UserSelectionData {
  iscadmin: boolean;
  divisionId: string;
  divisionName: string;
  instrumentId: string;
  instrumentType: string;
  roleId: string;
  roleType: RoleTypeNumber;
  hasMultipleRoles: boolean;
  state_roles: StateRole[];
  is_auction_user: boolean;
}

export interface LoginResponse extends UserData {
  companies?: CompanyDetailsMini[];
}

export interface CompanyDetailsMini {
  company_id: string;
  company_name: string;
  user_id?: string;
}

export interface OtherInvestorDetails {
  investor_name: string;
  dp_name: string;
  dp_id: string;
  client_id: number;
}

export interface Division {
  id?: string;
  corporate_admin_id?: string;
  name: string;
  city?: string;
  location?: string;
  is_ho?: boolean;
  seal_image?: string;
  AssociatedInstrument: Instrument[];
}

export interface Instrument {
  id?: string;
  AssociatedRole: Role[];
  division?: string;
  modified_at?: string;
  created_at?: string;
  status?: boolean;
  name: string;
  instrument_type: number;
}

export interface Role {
  id?: string;
  instrument?: string;
  depository_details: DepositoryDetail;
  modified_at?: string;
  created_at?: string;
  status?: boolean;
  name: string;
  role_type: RoleTypeNumber;
  state_role?: StateRole[];
}

export interface DepositoryDetail {
  id?: string;
  dp_id: string;
  dp_name: string;
  client_name: string;
  client_id: string;
  scheme_name: string;
  role_id?: string;
}

export interface DivisionDepository {
  division_id: string;
  division_name: string;
  depository_detail_id: string;
  dp_id: string;
  dp_name: string;
  client_name: string;
  client_id: string;
  role_id: string;
}

export interface ListingDetails {
  id: string;
  contact_name: string;
  telephone_numbers: string;
  designation: string;
  email: string;
  issuer_type: string;
  created_at: string;
  mobile_numbers: string;
  modified_at: string;
  role: string;
  status: boolean;
}

export interface FtracDetails {
  id: string;
  issuer_code: string;
  issuer_category: string;
  issuer_subcategory: string;
  industry_or_sector: string;
  issuer_long_term_credit_rating: string;
};

export interface SignatoryDoc {
  corporate_profile: string;
  created_at: string;
  doc_location: string;
  id: string;
  modified_at: string;
  signatories: SignatoryDetails[];
  status: boolean;
}

export interface SignatoryDetails {
  created_at: string;
  designation: string;
  email: string;
  facsimile_signature: string;
  id: string;
  is_test: boolean;
  mobile_number: string;
  modified_at: string;
  name: string;
  org_name: string;
  group_name: string;
  placement_character: string;
  signatories_doc: string;
  signatory_id: string;
  status: boolean;
}

export interface SignUploadDocsInput {
  isInitialSign: boolean;
  issue: string;
  user: string;
  shouldMakeTransition: boolean;
  signatoriesList: any[];
  documents: any[];
}

export interface SignatoryWithSigningStatus extends SignatoryDetails {
  signed: boolean;
  is_email_sent: boolean;
}

export interface SelectedSignatoryDetails {
  name: string;
  email: string;
  signed: boolean;
  is_email_sent: boolean;
}

export interface DocumentDetailsToView {
  title: string;
  additionalData?: string;
  document_url: string;
}

export interface DocumentAdditionalDataValidity {
  looDate: string;
  isMessageToBeShown: boolean;
  isBeforeLoo: boolean;
  issueValueDate: string;
}

export interface InvestmentDetails {
  deal_date: string;
  dealer_name: string;
  investor: string;
  roi: number;
  amount: number;
  is_offplatform_investor?: boolean;
  dp_id?: string;
  dp_name?: string;
  client_name?: string;
  client_id?: string;
  scheme_name?: string;
  company_name?: string;
  is_cbc?: boolean;
  user_email?: string;
  investor_user_id?: string;
}

export interface BackStopFacility {
  id: string;
  modified_at: string;
  created_at: string;
  status: boolean;
  description_instrument: string;
  issued_by: string;
  amount: number;
  expiry: string;
  in_favor_of: string;
  extent_of_guarantee_offerred: number;
  name_address_guarantor: string;
  net_worth_guarantor: number;
  conditions_invocation_guarantee: string;
  companies_guarantor_similar_guarantee: string;
  independent_trustee_details: string;
  documents: string;
  auction_id?: string;
}

export interface ClosedAuctionDetails {
  name: string;
  cp: string | null;
  rate: number;
  issue_cap: number;
  min_bid_value: number[];
  maturity_date: string;
  value_date: string;
  created_by: string;
  auction_privacy_type: auctionPrivacyTypes;
  issue_visibility_type: issueVisibilityTypes;
  issue_expiry_date: string;
  investment_details: InvestmentDetails[];
  cp_exists: boolean;
  is_issue_listing: boolean;
  value_date_frozen: boolean;
  auction_back_stop_facility: BackStopFacility;

}

export interface CpDetails {
  id?: string | null;
  name: string;
  cap: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ISIN_no: string | null;
  value_date: string;
  bank_stop_facility?: boolean;
  purpose: string;
  cp: IssueFormData[];
  cp_back_stop_facility: BackStopFacility | null;
  issue_count: number;
  status: boolean;
  maturity_date: string;
  maturity_date_frozen: boolean;
  is_approved?: boolean;
  approved_by?: string;
  approved_on?: string;
  created_by?: string;
  created_at?: string;
  updated_by?: string;
  updated_on?: string;
  modified_at?: string;
  division?: string;
}

export interface IssueFormData {
  id?: string;
  name: string;
  cp_exists?: boolean; // This field has been added for Auction
  cp: string;
  issue_cap: number;
  rate: number;
  value_date: string;
  maturity_date: string;
  auction_privacy_type: auctionPrivacyTypes;
  issue_visibility_type: issueVisibilityTypes;
  issue_visibility_list: string[];
  investment_details: InvestmentDetails[];
  is_issue_listing: boolean;
  min_bid_value: number;
  value_date_frozen: boolean;
  issue_expiry_date: string;
  status: boolean;
  created_by?: string;
  created_at?: string;
  created_on?: string;
  modified_at?: string;
  ISIN_no?: string | null;

}

export type auctionPrivacyTypes = 1 | 2;
export type issueVisibilityTypes = 1 | 0;

export type StateValues = 'accept_negotiation';

export interface FormattedMaturityDate {
  maturityDate: string;
  tenure: number;
}

export interface BidNegotiation {
  id: string;
  thread: string;
  is_active: boolean;
  amount: number;
  roi: number;
  bid_expiry: string;
  is_cbc: boolean;
  value_date: string;
  maturity_date: string;
  created_at: string;
  modified_at: string;
  bidder?: string;
  state_value: StateValues;
  bidState?: string;
}

export interface BidThread {
  id?: string;
  created_at?: string;
  modified_at?: string;
  status?: string;
  line_of_business?: string;
  bid?: BidNegotiation;
  investor_role?: string;
  investor_user?: string;
  investor_state?: StateObject;
  issuer_state?: StateObject;
  bidState?: string;
  investor_line_of_business?: string;
  formattedMaturityDate?: FormattedMaturityDate;
}

export interface StateObject {
  state: string;
  state_value: string;
  status: 'completed' | 'started';
}

export interface AuctionCustomPrivacyInvestor {
  company_name: string;
  id: string;
}

export interface AuctionObject {
  id?: string;
  modified_at?: string;
  created_at?: string;
  status?: boolean;
  name: string;
  desc: string;
  tentative_cap: number;
  amount?: number;
  minBidAmount?: number;
  tentative_rate: number;
  auction_privacy_type: auctionPrivacyTypes;
  issue_visibility_type: issueVisibilityTypes;
  tentative_maturity_date: string;
  formattedMaturityDate?: FormattedMaturityDate;
  tenure?: number;
  tentative_value_date: string;
  value_date_frozen?: string;
  maturity_date_frozen?: string;
  auction_expiry: string;
  is_closed: boolean;
  created_by?: string;
  issuer_role?: string;
  whitelist_roles: AuctionCustomPrivacyInvestor[];
  blacklist_roles: AuctionCustomPrivacyInvestor[];
  completion_percentage: number;
  bid_thread?: BidThread[];
  investor_accepted_bids?: any;
  accepted_bids?: BidNegotiation[];
  company_name?: string;
  issuer_company_name?: string;
  issuer_line_of_business?: string;
  credit_rating?: string;
  min_bid_amount: number;
  auction_back_stop_facility?: BackStopFacility;
  is_backstop_enabled?: boolean;
  is_carved_out_of_working_capital?: boolean;
}

export interface IssueFromAuctionStateConf {
  cpFormStatus: FormStatus;
  issueFormStatus: FormStatus;
  investorFormStatus: FormStatus;
  isinFormStatus: FormStatus;
}

export interface AdditionalDataBase {
  document_date: string;
}

export interface DcnAdditionalData extends AdditionalDataBase {
  issue_reference: string;
  issuer_dealer_name: string;
}
export interface ItoIpaAdditionalData extends AdditionalDataBase {
  place: string;
  // issuer_dealer_name: string;
}

export interface PromissoryAdditionalData extends AdditionalDataBase {
  place: string;
  document_date: string;
  serial_number: string;
  stamp_paper_doc: string;
}

export interface AdditionalDataOptionalDoc extends AdditionalDataBase {
  additional_doc?: string;
  description?: string;
}

export interface AllDocsAdditionalData {
  id: string;
  modified_at: string;
  created_at: string;
  status: boolean;
  master_creation_form: AdditionalDataBase;
  letter_of_offer: AdditionalDataBase;
  deal_confirmation_note: DcnAdditionalData;
  issuer_confirmation_to_IPA: ItoIpaAdditionalData;
  promissory_note: PromissoryAdditionalData;
  rbi_letter: AdditionalDataBase;
  covering_letter: AdditionalDataOptionalDoc;
  eligibility_letter: AdditionalDataOptionalDoc;
  CAF: AdditionalDataBase;
  cp_allotment: AdditionalDataBase;
  ipa_certificate: AdditionalDataBase;
  caf_issuance_letter: AdditionalDataBase;
  bse_annexure_a_listing: null;
  bse_annexure_ik_listing: null;
  bse_annexure_a_form_a_listing: null;
  bse_annexure_b_fresh_listing: null;
  bse_annexure_b_further_listing: null;
  bse_list_of_investors: null;
  nse_annexure_a_listing: null;
  nse_annexure_ik_listing: null;
  nse_annexure_a_form_a_listing: null;
  nse_annexure_b_fresh_listing: null;
  nse_annexure_b_further_listing: null;
  nse_list_of_investors: null;
  issue: string;
}



export interface IpaChecklist {
  id: string;
  modified_at: string;
  created_at: string;
  condition: IpaChecklistConditions;
  status: true;
  mode: string;
  issue: string;
}

export type IpaChecklistMap = {
  [key in IpaChecklistConditions]: string;
};

export interface LoginResponse {
  temp_session_id: string;
  credentials_public_key: string;
}
